import BarbaView from 'abstractions/BarbaView'

export default new BarbaView('home', {})
